<template>
    <div class="page-container">
        <div class="top-notice">您可在下方填写需要进货的信息，进行进货预算</div>
        <div class="form-block">
            <div class="form-title">填写进货数据</div>
            <div class="form-content-block">
                <div class="input-grp">
                    <div class="input-name">预进货商品</div>
                    <input type="text" class="input-ref" placeholder="请选择进货商品" />
                </div>
                <div class="input-grp">
                    <div class="input-name">预进货数量</div>
                    <input type="text" class="input-ref" placeholder="请输入进货数量" />
                </div>
                <div class="btn-confirm">查询</div>
            </div>
        </div>
        <div class="form-block">
            <div class="form-title">预算结果</div>
            <div class="form-content-block">
                <div class="input-grp">
                    <div class="input-name">本次可随货(箱)</div>
                    <input type="text" class="input-ref" placeholder="请选择进货商品" />
                </div>
                <div class="input-grp">
                    <div class="input-name">本次可获销售奖励(箱)</div>
                    <input type="text" class="input-ref" placeholder="请输入进货数量" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.page-container{
    min-height:calc(100vh - 46px);
    box-sizing: border-box;
    background:#fafafa;
    padding:10px;
    .top-notice{
        font-size: 14px;
        color:#999;
        line-height: 20px;
    }
    .form-block{
        margin-top: 15px;
        .form-title{
            color:#333;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 8px;
        }
        .form-content-block{
            background:#fff;
            padding:20px;
            .input-grp{
                font-size: 14px;
                color:#333;
                margin-bottom: 16px;
                .input-name{
                    margin-bottom: 6px;
                }
                .input-ref{
                    display: block;
                    box-sizing: border-box;
                    padding:0 15px;
                    background:#f5f5f5;
                    width:100%;
                    height:38px;
                    line-height: 38px;
                    font-size: 14px;
                    border:none;
                }
            }
            .btn-confirm{
                width: 180px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
                font-size: 14px;
                margin:0 auto;
                margin-top: 30px;
                color:#fff;
                @media screen and (max-width:750px){
                    border-radius: 26px;
                }
            }
        }
    }
}
</style>